import { gql } from '@apollo/client';

export default gql`
  mutation saveBookingToAllProfiles($customerId: String!, $bookingReference: String!, $reason: SaveBookingToAllProfilesReason = MANUAL) {
    saveBookingToAllProfiles(customerId: $customerId, bookingReference: $bookingReference, reason: $reason) {
      success
    }
  }
`;
